import { SortBarItemProps, useTranslations } from "@bsm/component";
import { useMemo } from "react";

export const useUserStudentFamilyListSort = () => {
    const [NAME, DATE] = useTranslations(i18n);
    return useMemo(
        () => [
            { label: NAME, value: "designation" },
            { label: DATE, value: "updatedAt", className: 'ml-auto' },
        ],
        []
    ) as Array<SortBarItemProps>;
};

const i18n = ["std_name", "std_date",];
